import type { Commodity } from './api';

/**
 * The Business profile catalog: every world price the company may pick,
 * grouped (ext_series.guide_group), optionally narrowed by what was typed.
 *
 * The search reads the plain sentence and the group as well as the name, so
 * "flour" finds the wheats and "cans" finds aluminium and tin: a user does not
 * have to know the Pink Sheet's names. Groups are alphabetical with "Other"
 * last; inside a group a series that stopped updating goes last.
 */
export function groupCatalog(
  list: Commodity[],
  query: string
): { group: string; items: Commodity[] }[] {
  const needle = query.trim().toLowerCase();
  const hit = (c: Commodity) =>
    !needle ||
    [c.name, c.about ?? '', c.group ?? ''].some((s) =>
      s.toLowerCase().includes(needle)
    );
  const groups = new Map<string, Commodity[]>();
  for (const c of list.filter(hit)) {
    const g = c.group || 'Other';
    groups.set(g, [...(groups.get(g) ?? []), c]);
  }
  return [...groups.entries()]
    .sort(([a], [b]) =>
      a === 'Other' ? 1 : b === 'Other' ? -1 : a.localeCompare(b)
    )
    .map(([group, items]) => ({
      group,
      items: [...items].sort((x, y) => Number(!!x.stale) - Number(!!y.stale))
    }));
}
